import { Sparkles, Type, Languages, MessageCircle, Mail, Phone, Globe, MapPin, Hash, FileText, CalendarClock, Building } from "lucide-react";

// حقول ملف الشركة — كل حقل معه أيقونة ولون accent للدلالة البصرية.
export const COMPANY_FIELDS = [
  { key: "nickname", label: "company.nickname", hint: "company.nicknameHint", icon: Sparkles, accent: "fuchsia" },
  { key: "name", label: "company.name", icon: Type, accent: "sky" },
  { key: "name_ar", label: "company.nameAr", icon: Languages, accent: "violet" },
  { key: "tagline", label: "company.tagline", icon: MessageCircle, accent: "cyan" },
  { key: "contact_email", label: "company.email", icon: Mail, accent: "sky" },
  { key: "phone", label: "company.phone", icon: Phone, accent: "emerald" },
  { key: "website", label: "company.website", icon: Globe, accent: "violet" },
  { key: "address", label: "company.address", hint: "company.addressHint", icon: MapPin, accent: "orange", type: "textarea" },
  { key: "trn", label: "branches.trn", icon: Hash, accent: "emerald" },
  { key: "trade_license_no", label: "branches.licenseNo", icon: FileText, accent: "sky" },
  { key: "license_expiry", label: "branches.licenseExpiry", icon: CalendarClock, accent: "rose", type: "date" },
  { key: "license_authority", label: "branches.licenseAuthority", icon: Building, accent: "amber" },
];

export const companyPayload = (form) =>
  Object.fromEntries(
    [...COMPANY_FIELDS.map((f) => f.key), "logo_url", "country", "region", "city", "lat", "lng"].map((key) => [key, form[key] === "" ? null : form[key] ?? null])
  );
